import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useGeneralStore } from "%/stores/general-store";

export const useMyPublicationFeedStore = defineSmartFeedPiniaStore("my-publication-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    metadata: {
      publicationOrgId: useGeneralStore().orgId,
      lastId: 0,
    },
  }),
  getters: {
    feedUrl() {
      return `/publication/org/${this.metadata.publicationOrgId}/smart-feed/status`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        status: "active",
      };
    },
  },
});
